import InfiniteScrollPrimitive from "react-infinite-scroller";
import styled from "styled-components";

export interface LayoutProps {
  height?: string;
}

export const Layout = styled.div<LayoutProps>`
  box-sizing: border-box;
  overflow: auto;
  flex: 1;
  ${({ height }) => height && `max-height: ${height};`};

  // Allows to display the box shadow on hover around the rows
  padding-left: 4px;
  padding-right: 4px;
  margin-left: -4px;
  margin-right: -4px;
  padding-bottom: 8px;
  margin-bottom: -8px;
`;

export const InfiniteScroll = styled(InfiniteScrollPrimitive)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
